import React from 'react'
import { Building2, Calendar, Hash } from 'lucide-react'
import {
  CompanyGroupEntry,
  CommandPaletteOption,
  CopyableValue,
  DetailsDescription,
  DetailsTitle,
  formatDate,
  getValue,
  SectionTitleWithButton,
} from '../CommandPalette_Utils'
import { InfoTable } from '../../../components/InfoTable/InfoTable'

type CompanyGroupDetailsProps = {
  companyGroup: CompanyGroupEntry
  onNavigateToCompanyGroup: (companyGroupId: string | number) => void
  onItemInteraction: (item: CommandPaletteOption) => void
}

export function CompanyGroupDetails({
  companyGroup,
  onNavigateToCompanyGroup,
  onItemInteraction,
}: CompanyGroupDetailsProps) {
  const handleSearch = () => {
    const id = companyGroup.id || companyGroup.name
    if (id && (typeof id === 'string' || typeof id === 'number')) {
      onItemInteraction(companyGroup)
      onNavigateToCompanyGroup(id)
    }
  }

  return (
    <>
      <DetailsTitle>{getValue(companyGroup.name)}</DetailsTitle>
      <DetailsDescription>
        <div>
          <SectionTitleWithButton
            title="General Details"
            buttonText="Go To Company Group"
            onButtonClick={handleSearch}
            buttonTitle="Navigate to this company group"
          />
          <InfoTable>
            <InfoTable.Row
              icon={<Hash size={14} />}
              label="Company Group ID"
              value={
                <CopyableValue
                  value={getValue(companyGroup.id)}
                  fieldName="Company Group ID"
                  item={companyGroup}
                  onItemInteraction={onItemInteraction}
                />
              }
            />
            <InfoTable.Row
              icon={<Calendar size={14} />}
              label="Created"
              value={
                companyGroup.createdAt
                  ? formatDate(String(companyGroup.createdAt))
                  : getValue(companyGroup.createdAt)
              }
            />
            <InfoTable.Row
              icon={<Building2 size={14} />}
              label="Company Count"
              value={getValue(companyGroup.companyCount)}
            />
          </InfoTable>
        </div>
      </DetailsDescription>
    </>
  )
}
